import { createFileRoute } from '@tanstack/react-router'
import { ViagensPage } from '@/pages/viagens/ViagensPage'

export const Route = createFileRoute('/_auth/viagens')({
  component: ViagensPage,
})
